import React from "react";
import styled from "styled-components";

import { StyledRow } from "../../../../../../../../../../components/common";

const Label = styled.div`
	font-family: Lato;
	font-size: 13px;
	font-style: normal;
	font-weight: 600;
	line-height: 16px;
`;

const Badge = styled.div`
	padding: 2px 4px;

	min-width: 24px;

	border-radius: 5px;

	background: #dee0e2;

	font-family: Lato;
	font-size: 9px;
	font-style: normal;
	font-weight: 600;
	line-height: 12px;
`;

const TabLabel: React.FC<TabLabel.Props> = ({ label, count }) => (
	<StyledRow alignItems="center" gap="8px" p="6px 14px 6px 11px">
		<Label>{label}</Label>
		<Badge>{count}</Badge>
	</StyledRow>
);

declare namespace TabLabel {
	interface Props {
		label: string;
		count: number;
	}
}

export default TabLabel;
